import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

interface BlogPost {
  id: number;
  title: string;
  content: string;
  created_at: string;
}

const PostList: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get("/Branches/posts/");
      setPosts(response.data);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: "100%" }}>
      <h2 className="text-center mb-4">Latest Posts</h2>
      {posts.length === 0 ? (
        <p className="text-center">No posts available</p>
      ) : (
        <div className="list-group">
          {posts.map((post) => (
            <Link
              to={`/posts/${post.id}`}
              key={post.id}
              className="list-group-item list-group-item-action"
            >
              <h5>{post.title}</h5>
              <p className="text-muted small">
                Posted on: {new Date(post.created_at).toLocaleDateString()}
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default PostList;
